module.exports = __webpack_public_path__ + "files/e088989c7441030d3995036994d940d7.png";